import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import $ from 'jquery';
import React, { Component } from 'react';
import { Modal } from "react-bootstrap";
import { FormattedMessage, injectIntl } from 'react-intl';
import { capitalize } from "../../name-helpers/nameFormatter";
import { getPriceListName } from "../../name-helpers/priceListNameHelper";
import { PROPOSAL_TYPE } from "../../state/proposal/ProposalType";
import { STOCK_DOCUMENT } from "../../utils/inventory";
import Icon from "../icon/icon.component.jsx";
import LoadingSpinner from "../spinner/loading.component.jsx";


const uuidv4 = require('uuid/v4')

class ProposalPreviewModal extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            modalId: this.props.modalId || 'proposal-preview-modal',
            hash: this.props.hash || '',
            publicLink: this.props.publicLink || '',
            documentId: this.props.documentId || '',
            proposalType: this.props.proposalType || 'quote',
            mobile: false,
            pdf: false,
            pdfLink: this.props.pdfLink || '',
            pdfLoading: false,
            pdfRequested: false,
            onTabChange: this.props.onTabChange || function () { },
        }
        this.closeModal = this.closeModal.bind(this)
        this.toggleMobileMode = this.toggleMobileMode.bind(this)
        this.toggleDesktopMode = this.toggleDesktopMode.bind(this)
        this.togglePdfMode = this.togglePdfMode.bind(this)
        this.pdfLoaded = this.pdfLoaded.bind(this)
    }

    componentDidMount() {
        $('#' + this.state.modalId).modal('show')
    }

    closeModal(event) {
        event.preventDefault()
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose(event)
        }
    }

    toggleMobileMode(event) {
        event.preventDefault()
        this.setState({
            mobile: true,
            pdf: false,
            loadingPdf: false,
        })
        this.state.onTabChange(true)
    }

    toggleDesktopMode(event) {
        event.preventDefault()
        this.setState({
            mobile: false,
            pdf: false,
            loadingPdf: false,
        })
        this.state.onTabChange(false)
    }

    togglePdfMode(event) {
        event.preventDefault()
        if (this.state.pdfRequested) {
            this.setState({
                pdf: true,
                mobile: false,
                loadingPdf: true,
            })
        } else {
            if (!this.props.hash) return

            AppContext.getApiClient().post('/proposals/' + this.props.hash + '/pdf').then(res => {
                this.setState({
                    pdf: true,
                    mobile: false,
                    loadingPdf: true,
                    pdfRequested: true,
                })
            })
        }
        this.state.onTabChange(false)
    }

    pdfLoaded() {
        this.setState({
            loadingPdf: false,
        })
    }

    getOpenButtonLabel() {
        switch (this.state.proposalType) {
            case 'invoice':
                return <FormattedMessage
                    id="common.preview_proposal.modal.open_invoice"
                    defaultMessage="Open invoice"
                />
            case STOCK_DOCUMENT:
                return <FormattedMessage
                    id="common.preview_proposal.modal.open_stock_document"
                    defaultMessage="Open"
                />
            case 'scheduling-page':
                return <FormattedMessage
                    id="common.preview_proposal.modal.scheduling_page"
                    defaultMessage="Open scheduling page"
                />
            case 'price-list':
                return <FormattedMessage
                    id="common.preview_proposal.modal.price_list"
                    defaultMessage="Open {priceList}"
                    values={{
                        priceList: capitalize(getPriceListName(this.props.intl))
                    }}
                />
            case PROPOSAL_TYPE.ACCOUNT_STATEMENT:
                return <FormattedMessage
                    id="common.preview_proposal.modal.account_statement"
                    defaultMessage="Open account statement"
                />
            default:
                return <FormattedMessage
                    id="common.preview_proposal.modal.open_proposal"
                    defaultMessage="Open proposal"
                />
        }
    }

    render() {
        const url = this.state.documentId ?
            AppContext.addApiKeysAsQueryParametersToPath('/p/proposals/dummy?documentId=' + this.state.documentId + `&mobile=${this.state.mobile}`) :
            '/p/proposals/' + this.props.hash + `?mobile=${this.state.mobile}`

        const iframe = this.state.pdf ? <iframe
            src={this.props.pdfLink}
            id={uuidv4() + '_pdf_iframe'}
            width="100%"
            height="550px"
            className={this.state.loadingPdf ? 'd-none' : ''}
            onLoad={this.pdfLoaded}
        /> : <iframe
            style={this.state.mobile ? { width: '375px' } : {}}
            src={url}
            id={this.state.modalId + '_iframe'} width="100%" height="550px" />
        return (
            <Modal
                show
                size={"xl"}
                className="modal fade"
                id={this.state.modalId}
                role="dialog"
                aria-labelledby="emailModalTitle"
                backdrop="static"
                data-keyboard="false"
            >
                <div role="document">
                    <div className="modal-content">
                        <div className="modal-header w-100 d-flex justify-content-center">
                            <div className="btn-group" role="group" aria-label="Basic example">
                                <button type="button" className={"btn btn-light " + (this.state.mobile || this.state.pdf ? "" : "active")} onClick={this.toggleDesktopMode}>
                                    <Icon value={"desktop"} />
                                </button>
                                <button type="button" className={"btn btn-light " + (this.state.mobile ? "active" : "")} onClick={this.toggleMobileMode}>
                                    <Icon value={"mobile-alt"} />
                                </button>
                                {this.props.pdfLink ? <button type="button" className={"btn btn-light " + (this.state.pdf ? "active" : "")} onClick={this.togglePdfMode}>
                                    <Icon value={"file-pdf"} />
                                </button> : ''}
                            </div>
                            {this.props.publicLink ? <div className={"ml-auto"}>
                                <a href={this.props.publicLink} target={'_blank'} className={'btn btn-outline-primary'}>
                                    <Icon value={"external-link-alt"} className={"mr-1"} />
                                    {this.getOpenButtonLabel()}
                                </a>
                            </div> : ''}
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row d-flex justify-content-center">
                                    {this.state.loadingPdf ? <div className={'w-100 text-center'}>
                                        <p><LoadingSpinner /></p>
                                        <p className={'mb-0'}>
                                            <FormattedMessage
                                                id="common.preview_proposal.modal.loading_pdf_message"
                                                defaultMessage="The pdf is generating, please bare with us during the process."
                                            />
                                        </p>
                                        <p>
                                            <FormattedMessage
                                                id="common.preview_proposal.modal.info_pdf_message"
                                                defaultMessage="Note that the pdf is automatically generated when you update or send your proposal"
                                            />
                                        </p>
                                    </div> : ''}
                                    {iframe}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={this.closeModal}>
                                <FormattedMessage
                                    id="common.preview_proposal.modal.close_btn"
                                    defaultMessage="Close"
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default injectIntl(ProposalPreviewModal)





// WEBPACK FOOTER //
// ./src/common/proposal/previewmodal.component.jsx